import { timelineItemClasses } from '@mui/lab'
import { Theme } from '@mui/material/styles'

const useStyles = {
  orderIcon: {
    height: '48px',
    aspectRatio: '1',
  },
  summaryFieldTitle: {
    lineHeight: '0.5',
  },
  copyIcon: {
    fontSize: '16px',
  },
  copyIconButton: (theme: Theme) => ({
    padding: 0,
    marginLeft: theme.spacing(1),
    width: '24px',
    height: '24px',
  }),
  timeline: {
    [`& .${timelineItemClasses.root}:before`]: { flex: 0, padding: 0 },
    margin: 0,
  },
  dateMissing: (theme: Theme) => ({
    marginTop: theme.spacing(1),
  }),
  deviceThumbnail: {
    width: '120px',
    height: '120px',
    marginLeft: '-10px',
  },
  changeModalActions: (theme: Theme) => ({
    marginBottom: theme.spacing(2),
  }),

  /* order container styles */
  orderContainer: (theme: Theme) => ({
    borderRadius: theme.shape.mediumBorderRadius + 4,
    margin: theme.spacing(0, 0, 3, 0),
    border: `1px solid ${theme.palette.action.selected}`,
  }),
  orderContainerExpandIcon: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
  orderContainerButton: (theme: Theme) => ({
    padding: theme.spacing(1.5),
    cursor: 'pointer',
  }),
  orderContainerChildWrapper: (theme: Theme) => ({
    padding: theme.spacing(1.5),
  }),
}

export default useStyles
